import { type ActiveCallSession } from 'tendril-v2/src/Data/DataSource/contacts-nest/callSession/entities/callSession.entity';
import { type ApiResponse } from 'tendril-v1/src/types/ApiResponse';
import axios from 'axios';
import routes from 'tendril-v1/src/constants/routes';

const getActiveCallSessions = async (): Promise<ApiResponse<ActiveCallSession[]>> => {
  try {
    const callSession = await axios.get<ActiveCallSession[]>(routes.get.callSession.getActiveCallSessions);
    return { data: callSession.data };
  } catch {
    return { error: { message: 'Error getting call sessions' } };
  }
};

export default getActiveCallSessions;
